import React, { useState, useEffect, useMemo } from 'react';
import TR from './../../Trans';
import { styled } from "@mui/material/styles";
import PropTypes from 'prop-types';
import 'video.js/dist/video-js.css';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import SongbookQueueDisable from '../dialogs/SongbookQueueDisable';
import LinearProgressWithLabel from '../items/LinearProgressWithLabel';
import Popover from '@mui/material/Popover';
import IntervalService from './../../services/intervals';
import { Views } from './../../enums/enums';
import { ReactComponent as MutedIcon } from './../../assets/muted.svg';
import ContentContainer from './../items/ContentContainer';
import FormControlLabel from '@mui/material/FormControlLabel';
import Select from '@mui/material/Select';
import { getOS, getPlatform, isIPhone, isPossiblyIPad } from '../../services/os';
import { Capacitor } from '@capacitor/core';
import SvgIcon from '@mui/material/SvgIcon';
import BackgroundMusicBottomBar from '../items/BackgroundMusicBottomBar';
import Tabs from '@mui/material/Tabs';
import List from '@mui/material/List';
import Tab from '@mui/material/Tab';
import Checkbox from '@mui/material/Checkbox';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import { ReactComponent as PlayIcon } from './../../assets/play.svg';
import { ReactComponent as PauseIcon } from './../../assets/pause.svg';
import { ReactComponent as NextIcon } from './../../assets/next.svg';
import { ReactComponent as PrevIcon } from './../../assets/prev.svg';
import BackgroundMusicList from '../player/BackgroundMusicList';
import BackgroundHistoryList from '../player/BackgroundHistoryList';
import Button from '@mui/material/Button';
import SelectSongbookPosition from '../dialogs/SelectSongbookPosition';
import Box from '@mui/material/Box';
import MuvikaService from './../../services/muvika';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Waiting from './../items/Waiting';
import SongbookQueueItem from '../items/SongbookQueueItem';
import { generateId } from './../../services/random';
import MuiToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import SongbookReject from '../dialogs/SongbookReject';
import { ReactComponent as VolumeIcon } from './../../assets/volume.svg';
import sessionStore from './../../stores/session';
import environmentStore from './../../stores/environment';
import musicPlayerStore from '../../stores/musicPlayer';
import bgPerformanceStore from '../../stores/bgPerformance';
import playerStore from '../../stores/player';
import settingsStore from '../../stores/settings';
import navigationStore from '../../stores/navigation';
import accountStore from '../../stores/account';
import singersStore from '../../stores/singers';
import bgFiltersStore from '../../stores/bgFilters';
import BgPlayerLinearProgressWithLabel from '../items/BgPlayerLinearProgressWithLabel';
import messageStore from '../../stores/message';
import songbookQueueStore from '../../stores/songbookQueue';
import performanceStore from '../../stores/performance';
import muvikaAttrs from './../../attrs';
import { setCommentRange } from 'typescript';
import { useLocalStorage } from '../../services/useLocalStorage';

const ToggleButton = styled(MuiToggleButton)({
  "&.Mui-selected, &.Mui-selected:hover": {
    background: "var(--text-color) !important",
    color: "var(--bg-color) !important"
  }
});

function SongbookQueue() {

  const sessionToken = sessionStore((state) => state.sessionToken);
  const queue = songbookQueueStore((state) => state.queue);
  const history = songbookQueueStore((state) => state.history);
  const setQueueingOn = songbookQueueStore((state) => state.setQueueingOn);
  const isQueueingOn = songbookQueueStore((state) => state.isQueueingOn);
  const addSongbookId = performanceStore((state) => state.addSongbookId);
  const addSingerLocally = singersStore((state) => state.addSingerLocally);
  const setIsAutoPlayOn = playerStore((state) => state.setIsAutoPlayOn);
  const addPerformanceFromSongbook = performanceStore((state) => state.addPerformanceFromSongbook);
  const playQueue = performanceStore((state) => state.playQueue);
  const deleteFromQueue = songbookQueueStore((state) => state.deleteFromQueue);
  const settingsSmartQEnabled = settingsStore((state) => state.settings?.smartq_enabled);
  const move = songbookQueueStore((state) => state.move);
  const setReqOld = songbookQueueStore((state) => state.setReqOld);
  const ipCounts = songbookQueueStore((state) => state.ipCounts);
  const idCounts = songbookQueueStore((state) => state.idCounts);
  const settings = settingsStore((state) => state.settings);
  const setSettings = settingsStore((state) => state.setSettings);
  const updateRemoveHistory = songbookQueueStore((state) => state.updateRemoveHistory);
  const accountLang = accountStore((state) => state.account?.language);
  const setIsWaiting = songbookQueueStore((state) => state.setIsWaiting);

  useEffect(() => { }, [accountLang]);

  const [reqPos, setReqPos] = useState(-1);

  const [selectedReqs, setSelectedReqs] = useState([]);

  const [isSelectSongbookPositionOpen, setSelectSongbookPositionOpen] = useState(false);
  const [isSongbookRejectOpen, setSongbookRejectOpen] = useState(false);
  const [isQueueDisableOpen, setQueueDisableOpen] = useState(false);
  const [chosenPos, setChosenPos] = useState(null);
  const [lastQueueCount, setLastQueueCount] = useState(null);

  const blinkLastItem = () => {
    const ul = document.getElementById("songbook-queue-droppable-list");
    if (!ul) return;

    // Select only direct <div> children
    const divItems = ul.querySelectorAll(":scope > div");
    if (!divItems.length) return;

    const lastItem = divItems[divItems.length - 1];

    lastItem.classList.add("blink-two-times");

    setTimeout(() => {
      lastItem.classList.remove("blink-two-times");
    }, 2000);
  };

  useEffect(() => {
    if (lastQueueCount !== null) {
      if (queue?.length > lastQueueCount) {
        updateRemoveHistory();
        blinkLastItem();
      }
    } else {
      updateRemoveHistory();
    }
    setLastQueueCount(queue ? queue.length : 0);
  }, [queue]);

  const handleOpenSelectSongbookPosition = () => {
    setSelectSongbookPositionOpen(true);
  };

  const handleCloseSelectSongbookPosition = () => {
    setSelectSongbookPositionOpen(false);
  };

  const handleOpenSongbookReject = () => {
    setSongbookRejectOpen(true);
  };

  const handleCloseSongbookReject = () => {
    setSongbookRejectOpen(false);
  };

  const handleOpenQueueDisable = () => {
    setQueueDisableOpen(true);
  };

  const handleCloseQueueDisable = () => {
    setQueueDisableOpen(false);
  };

  const handleChoosePosition = (pos) => {
    setChosenPos(pos);
    setSelectSongbookPositionOpen(false);
  };

  const renderSelectSongbookPosition = () => {
    return <SelectSongbookPosition
      open={isSelectSongbookPositionOpen}
      performances={playQueue?.items}
      requests={selectedReqs}
      onChoosePosition={handleChoosePosition}
      onClose={handleCloseSelectSongbookPosition}
    />;
  };

  const renderSongbookReject = () => {
    return <SongbookReject
      open={isSongbookRejectOpen}
      onDecline={declineSelected}
      onClose={handleCloseSongbookReject}
    />;
  };

  const handleOnDisable = () => {
    handleQueueOn();
    handleCloseQueueDisable();
  };

  const renderQueueDisable = () => {
    return <SongbookQueueDisable
      open={isQueueDisableOpen}
      onDisable={handleOnDisable}
      onClose={handleCloseQueueDisable}
    />;
  };

  const toggleSelectAll = () => {
    let newSelectedReqs = [...selectedReqs];
    if (newSelectedReqs.length === queue?.length) {
      newSelectedReqs = [];
    } else {
      newSelectedReqs = [...queue].map((req, index) => {
        if (req.req_type) {
          if (req.req_type === "add") {
            return req;
          }
        }
      });
    }
    setSelectedReqs(newSelectedReqs);
  };

  const toggleSelectedReq = (reqId) => {
    let newSelectedReqs = [...selectedReqs];
    let reqOnListIndex = newSelectedReqs.findIndex(x => x.id === reqId);
    if (reqOnListIndex != -1) {
      newSelectedReqs.splice(reqOnListIndex, 1);
    } else {
      let reqIndex = queue.findIndex(r => r.id === reqId);
      if (reqIndex != -1) {
        newSelectedReqs.push(queue[reqIndex]);
      }
    }
    setSelectedReqs(newSelectedReqs);
  };

  const setPosLast = () => {
    setReqPos(-1);
  };

  const setPosOther = () => {
    setReqPos(-2);
  };

  const handleReqPosChange = (event) => {
    let pos = event.target.value;
    if (pos && selectedReqs.length > 0) {
      let posInt = parseInt(pos);
      setReqPos(posInt);
      if (posInt == -2) {
        setSelectedReqs(sortSelectedReqs(selectedReqs));
        setSelectSongbookPositionOpen(true);
      }
    }
  };

  const handleQueueOn = () => {
    if (settings) {
      let newSettings = { ...settings };
      newSettings.sb_prequeue_enabled = isQueueingOn ? 0 : 1;
      setSettings(sessionToken, newSettings, false, true);
    }
  };

  const handleQueueCheckBoxChange = () => {
    if (isQueueingOn) {
      handleOpenQueueDisable();
    } else {
      handleQueueOn();
    }
  };

  const renderOnCheckBox = () => {
    return <FormControlLabel onChange={handleQueueCheckBoxChange} control={<Checkbox checked={isQueueingOn} />} label={TR.cm_enabled} />;
  };

  const renderDecline = () => {
    return <Button
      color="secondary"
      disabled={selectedReqs.length == 0}
      onClick={handleOpenSongbookReject}
    >{TR.cm_decline}</Button>;
  };

  const sortSelectedReqs = (reqs) => {
    const sorted = [];

    for (let i = 0; i < queue.length; i++) {
      const current = queue[i];

      let isSelected = false;
      for (let j = 0; j < reqs.length; j++) {
        if (reqs[j].id === current.id) {
          isSelected = true;
          break;
        }
      }

      if (isSelected) {
        sorted.push(current);
      }
    }
    return sorted;
  };

  const ackRequests = async (reqs, addToPos, isDeclining = false) => {
    setIsWaiting(true);
    let ackItems = [];
    let addUniqueIds = [];
    let ackPerformances = [];
    for (var i = 0; i < reqs.length; i++) {
      let item = reqs[i];
      console.log("ackItem", item);
      if (!ackItems.includes(item.id)) {
        let uniqueId = generateId(8);
        addUniqueIds.push(uniqueId);
        ackItems.push(item.id);
        ackPerformances.push(item);
      }
    }
    console.log("ackItems", reqs, addToPos, ackItems, ackPerformances, addUniqueIds);
    MuvikaService.ackSongbookRequest(sessionToken, ackItems, addUniqueIds)
      .then(async function (res) {
        if (!res.data.error) {
          for (let i = 0; i < ackPerformances.length; i++) {
            console.log("ackItem index", i, ackPerformances.length);
            let item = ackPerformances[i];
            if (!isDeclining) {
              if (!performanceStore.getState().songbookIds.includes(item.id)) {
                switch (item.req_type) {
                  case "add":
                    let uniqueId = addUniqueIds[i];
                    item.performance.unique_id = uniqueId;
                    let res = await MuvikaService.createSinger(sessionToken, item?.performance?.profile?.name, "", "");
                    if (res.data.data.id) {
                      addSingerLocally(res.data.data);
                      setIsAutoPlayOn(true);
                      console.log("ackRequests item", item);
                      console.log("inserting performance songbook", item);
                      addPerformanceFromSongbook(sessionToken, { ...item.performance }, addToPos || addToPos == 0 ? addToPos + i : null);
                    }
                    break;
                }
                addSongbookId(item.id);
              }
            }
            deleteFromQueue(item);
            console.log("ackItem index", i, ackPerformances.length);
          }
          setSelectedReqs(selectedReqs.filter(item => !new Set(reqs.map(r => r.id)).has(item.id)));
        } else {
          console.log("acking error", res.data.error);
        }
        setIsWaiting(false);
      })
      .catch(function () { setIsWaiting(false); });
  };

  const acceptSelected = () => {

  };

  const declineSelected = () => {
    let sortedSelectedReqs = sortSelectedReqs(selectedReqs);
    setSelectedReqs(sortedSelectedReqs);
    ackRequests(sortedSelectedReqs, null, true);
    handleCloseSongbookReject();
  };

  const handleAccept = () => {
    let sortedSelectedReqs = sortSelectedReqs(selectedReqs);
    setSelectedReqs(sortedSelectedReqs);
    if (reqPos == -1) {
      ackRequests(sortedSelectedReqs);
    } else if (reqPos == -2) {
      ackRequests(sortedSelectedReqs, chosenPos);
    }
    setReqPos(-1);
    setChosenPos(null);
  };

  const renderAccept = () => {
    return <Button
      color="success"
      disabled={selectedReqs.length == 0}
      onClick={handleAccept}
    >{TR.cm_accept}</Button>;
  };

  const renderSmartQOrLast = () => {
    if (settingsSmartQEnabled) {
      return <ToggleButton className="muvika-sbq-pos-toggle-button" value={-1}>
        SmartQ
      </ToggleButton>;
    } else {
      return <ToggleButton className="muvika-sbq-pos-toggle-button" value={-1}>
        {TR.cm_song_pos_last}
      </ToggleButton>;
    }
  };

  const renderOther = () => {
    let text = chosenPos || chosenPos == 0 ? "(" + (chosenPos + 1) + ")" : "";
    return <ToggleButton className="muvika-sbq-pos-toggle-button" value={-2}>
      {TR.cm_other + text}
    </ToggleButton>;
  };

  const requestIds = useMemo(() => {
    return queue?.filter((r) => r.req_type === "add").map((r) => r.id);
  }, [queue, selectedReqs]);

  const songRequestList = useMemo(() => {
    if (requestIds) {
      console.log("setQueue list", queue);
      return requestIds.map((reqId, index) => {
        return <SongbookQueueItem
          key={reqId}
          reqId={reqId}
          index={index}
          count={requestIds.length}
          draggableId={"songbook-queue-droppable-" + reqId}
          isSelected={selectedReqs.find(x => x.id === reqId)}
          onSelected={() => {
            toggleSelectedReq(reqId);
          }}
          onAccept={() => {
            console.log("queue accept");
            if (reqPos == -1) {
              ackRequests([queue.find(x => x.id === reqId)]);
            } else if (reqPos == -2) {
              ackRequests([queue.find(x => x.id === reqId)], chosenPos);
            }
          }}
          onDecline={() => {
            console.log("queue decline");
            ackRequests([queue.find(x => x.id === reqId)], null, true);
          }}
        />;
      });
    }
  }, [requestIds, history]);

  const handleDragEnd = (result) => {
    //console.log("drag end")
    if (result.destination) {
      let source = result.source.index;
      let dest = result.destination.index;
      if (source != dest) {
        move(source, dest);
      }
    }
  };

  const renderReqList = () => {
    if (queue) {
      if (queue.length > 0) {
        return <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId={"songbook-queue-droppable"}>
            {(provided, snapshot) => (
              <div {...provided.droppableProps} ref={provided.innerRef} >
                <List id="songbook-queue-droppable-list">
                  {songRequestList}
                </List>
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>;
      } else {
        return <p className={"muvika-aligned-center"}>{TR.cm_no_song_requests}</p>;
      }
    } else {
      return <p className={"muvika-aligned-center"}>{TR.cm_no_song_requests}</p>;
    }
  };

  const renderContainer = () => {
    if (isQueueingOn) {
      return <>
        <Grid container spacing={0} className="muvika-songbook-queue-nav">
          <Grid item xs={7}>
            <FormControlLabel className="muvika-check-all" onChange={toggleSelectAll} control={<Checkbox checked={selectedReqs.length === queue?.length} />} />
          </Grid>
          <Grid item xs={5}>
            <Stack direction="row" spacing={3} justifyContent="right">
              {renderDecline()}
              {renderAccept()}
              <ToggleButtonGroup
                exclusive
                disabled={selectedReqs?.length == 0}
                value={reqPos}
                onClick={handleReqPosChange}
                aria-label="text alignment"
                className="muvika-sbq-pos-buttons-group"
              >
                {renderSmartQOrLast()}
                {renderOther()}
              </ToggleButtonGroup>
            </Stack>
          </Grid>
        </Grid>
        <ContentContainer id={"muvika-songbook-queue"} onScrollDown={() => { }} isFinished={true} >
          {renderReqList()}
        </ContentContainer>
      </>;
    }
  };

  return (
    <div>
      {renderSelectSongbookPosition()}
      {renderSongbookReject()}
      {renderQueueDisable()}
      <Stack direction="row" spacing={1}>
        <h3 style={{ paddingBottom: "0" }}>{TR.cm_songbook_preapproval}</h3>
        {renderOnCheckBox()}
      </Stack>
      {renderContainer()}
    </div>
  );
};

export default SongbookQueue;